import React from 'react';
import InsightMaster from './InsightMaster';

function Concepts() {
  return (
    <InsightMaster
      title="Concepts"
      modalTitle="Add Concept"
      addButtonText="Add Concept"
      searchPlaceholder="Search concepts..."
      nameLabel="Concept Name *"
      namePlaceholder="Concept name"
      itemType="CONCEPT"
    />
  );
}

export default Concepts;
